module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "img-caption-processed"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.onResize
    }
  }), _c('div', {
    staticClass: "image",
    style: (_vm.styleObj)
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    ref: "lazyload",
    class: _vm.imageClass,
    attrs: {
      "data-style-type": _vm.imageDataStyleType,
      "tmp-src": _vm.imageUrl,
      "data-writer": _vm.imageDataWriter,
      "height": _vm.imageHeight,
      "width": _vm.imageWidth,
      "title": _vm.imageTitle
    }
  })]), (_vm.type === 'photo-essay') ? _c('div', {
    staticClass: "photo-share"
  }, [_c('share-buttons', {
    attrs: {
      "url": _vm.shareUrl,
      "title": _vm.imageTitle || _vm.shareData.title,
      "thumbnail": _vm.shareThumbnail,
      "avaliableIcons": {
        pinterest: true,
        email: false,
        whatsapp: false,
        messenger: false
      }
    }
  })], 1) : _vm._e(), (_vm.imageTitle.length > 0) ? _c('figcaption', [_vm._v(_vm._s(_vm.imageTitle))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54eacdd7","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/fields/body-items/Image.vue
// module id = 1102
// module chunks = 1 4 5